import { Select } from "components/Form/Select";
import { useFormContext } from "react-hook-form";
import { InputGroup } from "styles/InputGroup";

type RemoveCategoryProps = {
  hasCategory: boolean;
}

export function RemoveCategory({ hasCategory }: RemoveCategoryProps) {
  const { control } = useFormContext();

  return (
    <InputGroup flexItem>
      <Select
        name="remove_category"
        control={control}
        id="remove_category"
        label="Remover setor?"
        placeholder="Selecione"
        disabled={!hasCategory}
        fullwidth
        config={{
          noOptionsMessage: () => 'Sem opções.',
          options: [
            { value: true, label: 'Sim' },
            { value: false, label: 'Não' },
          ],
          closeMenuOnSelect: true,
        }}
      >
        <option value="false">Não</option>
        <option value="true">Sim</option>
      </Select>
    </InputGroup>
  );
}
